import React, { useContext, useEffect, useState } from 'react'
import './OverviewOrg.css'
import TotalRevenue from './ChartGraphs/TotalRevenue'
import TotalTicketsSold from './ChartGraphs/TotalTicketsSold'
import TotalEvents from './ChartGraphs/TotalEvents'
import TopEvent from './ChartGraphs/TopEvent'
import TicketByEvent from './ChartGraphs/TicketByEvent'
import EventsPieChart from './ChartGraphs/EventsPieChart'
import GeographyMap from './ChartGraphs/GeographyMap'
import EventContext from '../Events/EventContext'
import LoadingScreen from '../../../../LoadingScreen'
import UserContext from '../../../../UserContext'
import axios from 'axios'

const Overview = () => {
    // const {orgStats,setOrgStats} = useContext(EventContext);
    const [loading,setLoading] = useState(true);
    const {userInfo} = useContext(UserContext)
    const [orgStats,setOrgStats] = useState(null)

    const getOrganizerStats = async (id) => {
      try {
        const response = await axios.get(`https://event-finder12.onrender.com/data/organizerData/${id}`)
        setOrgStats(response.data);
        setLoading(false);
        console.log(response.data)
      } catch (err) {
        console.log(err);
      }
  }


    useEffect(()=> {
        getOrganizerStats(userInfo.email);
    },[]);




  return (
    <div>
      {loading ? <LoadingScreen/> : ( <>
        <div className="small-details-divs">
        <div className="small-detail">
              <TotalRevenue income={orgStats.revenue}/>
          </div>
          <div className="small-detail margin-right">
              <TotalTicketsSold sold= {orgStats.ticketsPurchased}/>
          </div>
          <div className="small-detail">
              <TotalEvents totalEventCreated= {orgStats.totalEventCreated}/>
          </div>
          <div className="small-detail">
              <TopEvent topEvent={orgStats.topEvent}/>
          </div> 
        </div>
        <div className="first-row-charts">
          <div className="first-row-chart">
            <TicketByEvent stats={orgStats.salesByEventCategory}/>
          </div>
          <div className="first-row-chart">
            {" "}
            <EventsPieChart events={orgStats.Eventbreakdown}/>
          </div>
        </div>
        <div className="first-row-charts last-row">
          <div className="map">
            <GeographyMap data= {orgStats.ticketsByCountry}/>
          </div>
        </div>
        </>)}
    
  </div>
  )
}

export default Overview